<template>
  <div class="exam_page">
    <div class="exam_main" ref="middle_page">
        <div class="examPage">
        <div class="primarylists list-mobile">
            <div class="titles clear titles-new-ps">
                <img src="../../../static/images/icon-st.jpg" alt="" />
                <div class="title l">{{ this.$route.query.courseName }}</div>
            </div>
        </div>
        
        <div class="exam_begins_box exam_begins_mg_t">
            <p class="examination_title">
            {{ $t("preview.examList") }}
            </p>
            <!-- list -->
            <div class="lkt-flex" v-if="isLoadData">
              <!-- <template v-if="examFlag != 0">
                <div class="lkt_mg_tl_30px">
                  <div :class="[{title_question_s: statusExam}, {lkt_title_question_s: !statusExam}]" style="width: 100%;" @click="statusExam ? goToListWrongBookExam() : false">
                    <img class="icon_status_question" v-if="statusExam" src="../../../static/images/icon-kt.png"/>
                    <img class="icon_status_question" v-else src="../../../static/images/icon-kt-den.png"/>
                    <div class="flex-right">
                      <div class="lkt_titleExam" :class="[{test_content: statusExam}, {lkt_test_content: !statusExam}]">
                        {{$t('curriculum.exam')}}
                      </div>
                      <div class="lkt_quantityWrong" :class="[{test_content: statusExam}, {lkt_test_content: !statusExam}]">
                        {{$t('new.title103')}} : {{quantityWrongExam}}
                      </div> 
                    </div>
                  </div>
                </div>
              </template> -->

              <template v-if="examFlag != 0">
                <div class="lkt_mg_tl_30px">
                  <div :class="[{title_question_s: statusExam}, {lkt_title_question_s: !statusExam}]" style="width: 100%;" @click="statusExam ? goToListFinalCourse() : false">
                    <img class="icon_status_question" v-if="statusExam" src="../../../static/images/icon-kt.png"/>
                    <img class="icon_status_question" v-else src="../../../static/images/icon-kt-den.png"/>
                    <div class="flex-right">
                      <div class="lkt_titleExam" :class="[{test_content: statusExam}, {lkt_test_content: !statusExam}]">
                        {{$t('curriculum.exam')}}
                      </div>
                    </div>
                  </div>
                </div>
              </template>


              <!-- <template v-for="(item, index) in listExamMidTerm">
                <div class="lkt_mg_tl_30px" :key="index">
                  <div :class="[{title_question_s: item.statusMidTerm}, {lkt_title_question_s: !item.statusMidTerm}]" style="width: 100%;" @click="item.statusMidTerm ? goToListWrongBookMidTerm(item) : false">
                    <img class="icon_status_question" v-if="item.statusMidTerm" src="../../../static/images/icon-kt.png"/>
                    <img class="icon_status_question" v-else src="../../../static/images/icon-kt-den.png"/>
                    <div class="flex-right">
                      <div class="lkt_titleExam" :class="[{test_content: item.statusMidTerm}, {lkt_test_content: !item.statusMidTerm}]">
                        <span>{{item.examName}}</span>
                      </div> 
                      <div class="lkt_quantityWrong" :class="[{test_content: item.statusMidTerm}, {lkt_test_content: !item.statusMidTerm}]">
                        {{$t('new.title103')}} : {{item.quantityWrongMidTerm}}
                      </div>
                    </div>
                  </div>
                </div>
              </template> -->
              
            </div>
            <div class="exambutton">
                <button
                class="el-button form_btn login_button1 btn-login el-button--default is-round"
                @click="backToMenu"
                >
                    {{ $t("examBegins.giveUp") }}
                </button>
            </div>
        </div>
      </div>
    </div>
    <loading class="loading--lesson" :showLoading="!isLoadData" />
  </div>
</template>

<script>
import loading from "@/components/loading/loading";

export default {
  name: "preview",
  data() {
    return {
      userId: null,
      courseId: null,
      checkExam: false,
      statusExam: false,
      listExamMidTerm: [],
      isLoadData: false,
      quantityWrongExam: 0,
      examFlag: this.$route.query.examFlag,
      courseName: this.$route.query.courseName
    };
  },
  components: {
    loading,
  },
  mounted() {
    const h = document.body.clientHeight - 299;
  },
  async created(){
    const self = this;
    this.$autoLogin().then(
      async () => {
        this.courseId = this.$route.query.courseId;
        this.userId = window.sessionStorage.getItem("id");
        this.role = window.sessionStorage.getItem("role");
        let examList = await this.getExamList(this.courseId);
        Promise.all(examList.map(item => {
          return self.getWrongBook(item);
        })).then( function(results) {
          self.listExamMidTerm = results;
          self.isLoadData = true;
        });
      },
      () => {
        this.$router.push({
          path: "/home",
        });
      }
    );
    let category = await this.getCourseCategory(this.$route.query.courseId);
    let result = this.getCurriculum(category.courseCategoryCode);
    let isExam;
    result.forEach(element => {
        isExam = element.menuList.filter(item => item.name == 'THI__CUOI__KI' && item.show == true);
    });
    if(isExam){
        this.checkExam = true;
    }
    this.checkFinalExamFinal();
  },
  methods: {
    getWrongBook: function (data) {
        return new Promise((resolve, reject) => {
            this.$api
            .post("/studyCourseQuestion/getWrongBook", {
                languageType: this.$lang(),
                courseId: this.courseId,
                examId: data.examId
            })
            .then(response => {
                data['statusMidTerm'] = response.data.length > 0 ? true : false;
                data.quantityWrongMidTerm = response.data.length;
                resolve(data);
            })
            .catch((err) => {reject(err.response)});
        });
    },
    getExamList: function (courseId) {
        return new Promise((resolve, reject) => {
            this.$api
            .post("/courseStudy/getExamList", {
                courseId: courseId,
            })
            .then(response => {
                resolve(response.data);
            })
            .catch((err) => {reject(err.response)});
        });
    },
    backToMenu: function () {
      this.$router.push({
        name: "Aicourse",
        query: {
          buyCourseId: this.courseId
        },
      });
    },
    getCourseCategory: function (courseId) {
        return new Promise((resolve, reject) => {
            this.$api
            .post("/courseStudy/getCourseCategory", {
                courseId: courseId,
            })
            .then(response => {
                resolve(response.data);
            })
            .catch((err) => {reject(err.response)});
        });
    },
    goToListFinalCourse: function() {
        this.$router.push({
            path: "/home/exam/examBook",
            query: {
                courseId: this.courseId,
                examId: '',
                courseName: this.$route.query.courseName,
                examFlag: this.examFlag,
            }
        });
    },
    // goToListWrongBookMidTerm (params) {
    //   console.log('params',params)
    //     this.$router.push({
    //         path: "/home/exam/wrongbook",
    //         query: {
    //             courseId: this.courseId,
    //             examId: params.examId,
    //             courseName: this.$route.query.courseName,
    //             examFlag: this.examFlag,
    //         }
    //     });
    // },
    checkFinalExamFinal () {
        this.$api
        .post("/studyCourseQuestion/getExamQuestionsByCourseIdPreview", {
            courseId: this.courseId
        })
        .then((response) => {
            if(response.data.questions.length > 0){
                this.statusExam = true;
            }
        });
    }
  },
};
</script>

<style scoped="scoped">


@import "../../../static/css/exam.css";

.flex-right .lkt_quantityWrong {
  max-width: 150px;
}

.flex-right .lkt_titleExam {
  width: calc(100% - 150px);
}

.lkt_mg_tl_30px {
  margin: 0 10px;
}

.lkt_title_question_s {
    color:#000000;
        overflow: hidden;
        text-overflow: ellipsis!important;
        border: 1px #000000 solid !important;
        margin-bottom: 3px;
        margin-top: 3px;
        border-radius: 5px;
        padding:5px 10px 5px 10px;
        background: rgb(230, 229, 229);
        display:flex;
        align-items: center;
}
.lkt_test_content{
        display: -webkit-box;
        -webkit-box-orient: vertical!important;
        -webkit-line-clamp: 1;
        overflow: hidden;
        color:#000000;
        font-weight: bold;
        font-size: 16px;
        height: 19px;
    }

.title_question_s{
        color:#0071c5;
        overflow: hidden;
        text-overflow: ellipsis!important;
        border: 1px #0071c5 solid !important;
        margin-bottom: 3px;
        margin-top: 3px;
        cursor: pointer;
        border-radius: 5px;
        padding:5px 10px 5px 10px;
        display:flex;
        align-items: center;
    }
    .test_content{
        display: -webkit-box;
        -webkit-box-orient: vertical!important;
        -webkit-line-clamp: 1;
        overflow: hidden;
        color:#0071c5;
        font-weight: bold;
        font-size: 16px;
        height: 17px;
    }
    .title_question_s:hover{
        border: 1px #0071c5 solid !important;
        background-color: rgb(243, 243, 243);
    }
    .icon_status_question{
        width: 30px;
        height: 30px;
        margin-right:5px
    }
   .lkt_mg_tl_30px{
     width:calc(50% - 20px)
   }
   .lkt-flex{display:flex;flex-wrap: wrap;}
.exam_begins_box {
  max-width: 900px;
  width: 90%;
  padding: 30px 5%;
  border-radius: 15px;
  margin: 40px auto 0;
  box-shadow: 0px 1px 10px 1px rgba(0, 0, 0, 0.3);
  position: relative;
}

.examination_notes {
  height: 20px;
  font-size: 20px;
  color: red;
  text-align: left;
  font-weight: 200;
  font-style: normal;
  padding: 5px 10px;
}

.examination_title {
  font-size: 28px;
  background: #0071c5;
  text-align: center;
  font-weight: 200;
  font-style: normal;
  padding: 10px 0;
  margin-bottom: 20px;
  color: #fff;
  border-top-left-radius: 15px;
  border-top-right-radius: 15px;
}

.exam_begins_box .exam_begins_rule {
  position: relative;
  margin-top: 20px;
  padding-top: 20px;
  border-top: 1px #414141 solid;
}

.exam_begins_rule .exam_begins_rule_title {
  min-width: 80px;
  height: 20px;
  padding-right: 10px;
  font-size: 14px;
  color: #000;
  font-weight: 200;
  font-style: normal;
  width: 200px;
  font-weight: bold;
  text-align: right;
  float: left;
}
.exam_begins_rule_content {
  width: calc(100% - 200px);
  float: left;
}

.exam_begins_rule .exam_begins_rule_content {
  /*width: 520px;*/
  min-height: 20px;
  position: relative;
  display: block;
}

.exam_begins_rule .exam_begins_rule_content p {
  min-height: 20px;
  line-height: 26px;
  display: flex;
  font-size: 14px;
  color: #000;
  text-align: left;
  font-weight: 200;
  font-style: normal;
}

.exam_notes {
  font-size: 14px;
  color: #000;
  display: flex;
  width: 100%;
  padding: 5px 0;
}
.exam_notes span.ex-r {
  width: calc(100% - 200px);
  float: left;
}
.exam_notes span.ex-l {
  width: 200px;
  font-weight: bold;
  text-align: right;
  padding-right: 10px;
  float: left;
}
.exambutton {
  text-align: center;
}
.exam_btn {
  margin-top: 40px;
  display: inline-block;
  text-align: center;
  font-size: 12px;
  color: #e8e6e6;
  background-color: unset;
  padding: 4px 10px 6px 10px;
  border: 1px solid #e8e6e6;
  border-radius: 20px;
  font-family: source-han-sans-simplified-c, sans-serif;
  font-weight: 200;
  font-style: normal;
  transition: 0.5s ease;
}
.return {
  margin-top: 40px;
  margin-left: 40px;
  display: inline-block;
  text-align: center;
  font-size: 12px;
  color: #e8e6e6;
  background-color: unset;
  padding: 4px 10px 6px 10px;
  border: 1px solid #e8e6e6;
  border-radius: 20px;
  font-family: source-han-sans-simplified-c, sans-serif;
  font-weight: 200;
  font-style: normal;
  transition: 0.5s ease;
}
.exambutton .btn-login {
  width: auto !important;
  min-width: 120px;
  padding: 0 10px !important;
}

.exam_btn:hover {
  color: #000;
  background-color: #fff;
  transition: 0.5s ease;
}

.return:hover {
  color: #000;
  background-color: #fff;
  transition: 0.5s ease;
}
.flex-right{display:flex;justify-content: space-between;width:100%}
@media screen and (max-width: 1024px) {
  .exam_begins_box {
    width: 94%;
    padding: 3%;
  }
}
@media screen and (max-width: 480px) {
  .lkt-flex{flex-direction: column;}
  .lkt_mg_tl_30px{
    width: 96%;
    margin:5px 2%
  }
}
.primarylists .titles .title {
  text-transform: none!important;
}
</style>



// WEBPACK FOOTER //
// src/views/exam/preview.vue